import { render, staticRenderFns } from "./MessageTypePicker.vue?vue&type=template&id=231bbecd&scoped=true&"
import script from "./MessageTypePicker.vue?vue&type=script&lang=js&"
export * from "./MessageTypePicker.vue?vue&type=script&lang=js&"
import style0 from "./MessageTypePicker.vue?vue&type=style&index=0&id=231bbecd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231bbecd",
  null
  
)

export default component.exports